<p-autoComplete
    #autoComplete
    styleClass="w-full"
    [formControl]="formControl"
    [formlyAttributes]="field"
    (completeMethod)="complete($event)"
    [suggestions]="currentItemsComputed()"
    (onSelect)="onSelect($event)"
    [autoOptionFocus]="true"
    optionLabel="postalCode"
    [delay]="debounceTime"
    [lazy]="true"
>
    <ng-template let-postalCode #item>
        <div class="flex items-center gap-1">
            <!-- <img
                src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                [class]="'flag flag-' + country.code.toLowerCase()"
                style="width: 18px"
            /> -->
            <span class="font-bold">{{ postalCode.postalCode }}</span>
            <span>{{ postalCode.city }}</span>
            <span class="italic text-slate-400 text-sm">{{ postalCode.state }}</span>
        </div>
    </ng-template>
</p-autoComplete>
